export default [
  {
    header: 'Dashboard',
    resource: 'APP.DASHBOARD',
    action: 'read',
  },
  {
    title: 'Anasayfa',
    route: 'home',
    icon: 'HomeIcon',
    resource: 'APP.DASHBOARD',
    action: 'read',
  },
  {
    header: 'Yönetim',
    resource: 'users.list',
    action: 'read',
  },
  {
    title: 'Kullanıcılar',
    route: 'Users',
    icon: 'UsersIcon',
    children: [
      {
        title: 'Kullanıcılar',
        route: 'Users',
        resource: 'users.list',
        action: 'read',
      },
      {
        title: 'Kullanıcı Yetkileri',
        route: 'UserTypes',
        resource: 'ADMIN_USER_TYPE_LIST',
        action: 'read',
      },
    ],
  },
]
